import {
  Activity,
  Bookmark,
  Calendar,
  CalendarArrowUp,
  Database_01,
  EmailScheduled,
  IconCallback,
  Indeed,
  IndeedSent,
  Linkedin,
  LinkedinFill,
  Mail_01,
  MailArrowDown,
  MailArrowUp,
  MailX,
  Pencil_01,
  Phone,
  RobinIcon,
  Tag_01,
  Upload_01,
  UserCheck_01,
  Werknl,
  Whatsapp,
  XClose,
} from '@recruit-robin/robin-theme/web-icons';
import { ThemeColorCallback } from '@recruit-robin/robin-theme/web-styles';

import { ActivityLogAction, ActivityLogSendMethod } from '../../model';

export const getActivityIcon = ({
  source,
  action,
  size,
  color = 'currentColor',
}: {
  action: ActivityLogAction;
  size: number;
  source?: ActivityLogSendMethod | undefined;
  color?: ThemeColorCallback;
}): React.ReactNode => {
  const sourceIcon: Record<ActivityLogSendMethod, IconCallback> = {
    [ActivityLogSendMethod.Call]: Phone,
    [ActivityLogSendMethod.Werknl]: Werknl,
    [ActivityLogSendMethod.Whatsapp]: Whatsapp,
    [ActivityLogSendMethod.Email]: Mail_01,
    [ActivityLogSendMethod.InMail]: LinkedinFill,
    [ActivityLogSendMethod.Indeed]: IndeedSent,
    [ActivityLogSendMethod.Linkedin]: Linkedin,
  };

  const actionIcon: Record<ActivityLogAction, IconCallback | null> = {
    [ActivityLogAction.Contacted]: null,
    [ActivityLogAction.Hidden]: XClose,
    [ActivityLogAction.Invisible]: RobinIcon,
    [ActivityLogAction.LabelChanged]: Tag_01,
    [ActivityLogAction.Matched]: UserCheck_01,
    [ActivityLogAction.Note]: Pencil_01,
    [ActivityLogAction.SentToAts]: Upload_01,
    [ActivityLogAction.Shortlisted]: Bookmark,
    [ActivityLogAction.Unlocked]: RobinIcon,
    [ActivityLogAction.AtsCandidateContact]: Database_01,
    [ActivityLogAction.AtsNoteCreated]: Database_01,
    [ActivityLogAction.AtsStatusChanged]: Database_01,

    [ActivityLogAction.EmailSent]: Mail_01,
    [ActivityLogAction.EmailReceived]: Mail_01,
    [ActivityLogAction.FollowUpPlanned]: EmailScheduled,
    [ActivityLogAction.FollowUpSent]: Mail_01,
    [ActivityLogAction.MessageReceived]: Mail_01,
    [ActivityLogAction.LinkedinSent]: Linkedin,
    [ActivityLogAction.LinkedinReceived]: Linkedin,
    [ActivityLogAction.IndeedSent]: IndeedSent,
    [ActivityLogAction.IndeedReceived]: Indeed,
    [ActivityLogAction.InMailSent]: LinkedinFill,
    [ActivityLogAction.InMailReceived]: LinkedinFill,

    [ActivityLogAction.RJCommHubPipelineExpired]: MailX,
    [ActivityLogAction.RJCommHubInitialMessageSent]: MailArrowUp,
    [ActivityLogAction.RJCommHubFollowUpPlanned]: EmailScheduled,
    [ActivityLogAction.RJCommHubFollowUpSent]: MailArrowUp,
    [ActivityLogAction.RJCommHubCandidateAccepted]: MailArrowDown,
    [ActivityLogAction.RJCommHubCandidateRejected]: MailArrowDown,
    [ActivityLogAction.CandidateAppliedRecommendation]: MailArrowDown,

    [ActivityLogAction.CalendarInterviewInvitationSent]: CalendarArrowUp,
    [ActivityLogAction.CalendarInterviewInvitationAccepted]: Calendar,
    [ActivityLogAction.CalendarInterviewInvitationRescheduled]: Calendar,
    [ActivityLogAction.CalendarInterviewInvitationRejected]: Calendar,
  };

  const icon = actionIcon[action] || (source && sourceIcon[source]);

  return icon?.({ size, color }) || <Activity size={size} color={color} />;
};
